/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "sofa-7c587e41--sprite",
  "use": "sofa-7c587e41--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"sofa-7c587e41--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(56.263 -234.47)\"><path d=\"M17.408,252.48a4.133,4.133,0,0,1,3.841-4.143,6.881,6.881,0,0,0-3.594-4.363c-2.282-1.245-5.588-1.874-9.831-1.874s-7.549.629-9.831,1.874A6.914,6.914,0,0,0-5.6,248.337a4.132,4.132,0,0,1,3.841,4.143v.616a14.807,14.807,0,0,1,4.143-.555,14.722,14.722,0,0,1,4.156.562,4.515,4.515,0,0,0,2.563,0,14.756,14.756,0,0,1,4.156-.562,14.807,14.807,0,0,1,4.143.555v-.616Z\" transform=\"translate(-46.087)\" fill=\"currentColor\" /><path d=\"M63.1,415.909a5.652,5.652,0,0,1-3.232,0,13.613,13.613,0,0,0-3.821-.509,13.142,13.142,0,0,0-4.143.622v1.626a.674.674,0,0,0,.676.676H70.391a.674.674,0,0,0,.676-.676v-1.626a13.142,13.142,0,0,0-4.143-.622A13.593,13.593,0,0,0,63.1,415.909Z\" transform=\"translate(-99.739 -161.702)\" fill=\"currentColor\" /><path d=\"M-24.456,352.6h-.181a2.965,2.965,0,0,0-2.884,2.991v3.46a1.839,1.839,0,0,1-1.84,1.84H-47.17a1.839,1.839,0,0,1-1.84-1.84v-3.46a2.965,2.965,0,0,0-2.884-2.991h-.167a3.09,3.09,0,0,0-2.925,2.871,3.077,3.077,0,0,0,.823,2.3c.074.08.154.154.234.228A5.435,5.435,0,0,1-52,362.1V363.9a2.048,2.048,0,0,0,2.048,2.048h23.37A2.052,2.052,0,0,0-24.53,363.9V362.1A5.4,5.4,0,0,1-22.6,358c.08-.074.161-.147.234-.228a3.033,3.033,0,0,0,.823-2.3A3.083,3.083,0,0,0-24.456,352.6Z\" transform=\"translate(0 -103.105)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
